// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2C1n4","topBottomGutter":"Layout_topBottomGutter__FbmUO"};